import { render, staticRenderFns } from "./SkeletonText.vue?vue&type=template&id=0fdcc474&scoped=true"
import script from "./SkeletonText.vue?vue&type=script&lang=js"
export * from "./SkeletonText.vue?vue&type=script&lang=js"
import style0 from "./SkeletonText.vue?vue&type=style&index=0&id=0fdcc474&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdcc474",
  null
  
)

export default component.exports